// The HUD stage: a plain wrapper around the HUD elements. During HUD editing it
// gets a width (viewport minus the properties panel) and a transform, which
// makes it the containing block for the fixed HUD children. Outside the editor
// it has no styles, so fixed elements behave exactly as before.
//
// NOTE: the stage itself has no in-flow content (all children are fixed), so
// its clientHeight is 0 and its flow position can sit below the canvas. Never
// use its rect outside editing — use the window then.

export function hudStage(): HTMLElement | null {
  return document.getElementById("hud-stage");
}

function editing(): boolean {
  return document.body.classList.contains("hud-editing");
}

export function hudStageSize(): { w: number; h: number } {
  if (!editing()) return { w: window.innerWidth, h: window.innerHeight };
  const stage = hudStage();
  if (!stage) return { w: window.innerWidth, h: window.innerHeight };
  return {
    w: stage.clientWidth || window.innerWidth,
    h: stage.clientHeight || window.innerHeight,
  };
}

export function hudStageRect(): { x: number; y: number; w: number; h: number } {
  if (!editing()) return { x: 0, y: 0, w: window.innerWidth, h: window.innerHeight };
  const stage = hudStage();
  if (!stage) return { x: 0, y: 0, w: window.innerWidth, h: window.innerHeight };
  const r = stage.getBoundingClientRect();
  return {
    x: r.left,
    y: r.top,
    w: stage.clientWidth || window.innerWidth,
    h: stage.clientHeight || window.innerHeight,
  };
}
